import { render, staticRenderFns } from "./SettingsTaskTypes.vue?vue&type=template&id=6841c8dd"
import script from "./SettingsTaskTypes.vue?vue&type=script&lang=js"
export * from "./SettingsTaskTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsTaskTypes.vue?vue&type=style&index=0&id=6841c8dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports